import React from "react";

const JumlahKendBermotor = () => {
  return (
    <div style={{ width: "100%", height: "600px" }}>
      <iframe
        title="Jumlah Kendaraan Bermotor"
        src="https://lookerstudio.google.com/embed/reporting/f2ae83a3-0b3f-4007-a615-a4cbafcb4625/page/1M"
        width="100%"
        height="100%"
        style={{
          border: 0,
          overflow: "hidden",
        }}
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default JumlahKendBermotor;
